/**
 * Copyright (c) ActiveWidgets SARL. All Rights Reserved.
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {SvelteComponent} from './framework.js';
import {Datagrid as _Datagrid, Row as _Row, Cells as _Cells} from '@activewidgets/datagrid';

export const Datagrid = SvelteComponent(_Datagrid);
export const Row = SvelteComponent(_Row);
export const Cells = SvelteComponent(_Cells);
